import React, { Fragment } from "react";
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import DatePicker from "react-datepicker";

function DatePickerFormated(props) {
  const parsedMinDate = props.minDate ? new Date(props.minDate) : null;
  const parsedMaxDate = props.maxDate ? new Date(props.maxDate) : null;
  let errorBorder = "";
  const years = (function () {
    var currentYear = new Date().getFullYear(),
      years = [];
    let startYear = props.minYear || 1920;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years;
  })();

  // months in arabic
  const months = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "اكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];

  // Change date format to string format
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  // Prevent entering data via keyboard or other methods
  const handleKeyDown = (e) => {
    // If Backspace is pressed, clear the value
    if (
      e.code === "Backspace" ||
      e.code === "Delete" ||
      e.code === "Escape" ||
      e.code === "Space"
    ) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        "", // Clear the value
        props.index,
        props.buildingIndex,
      );
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name_datepicker,
        null, // Clear the datepicker value
        props.index,
        props.buildingIndex,
      );
    } else {
      e.preventDefault(); // Prevent all other keyboard input
    }
  };

  const handleDateChange = (e) => {
    const fullDate = formatDate(e);
    // set two dates format one for validation with national id
    // and another to datepicker
    // Validate against regex if provided
    if (props.allowedPattern && !props.allowedPattern.test(fullDate)) {
      console.log("Invalid date format");
      return; // Do not proceed if the date format is invalid
    }
    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name,
      fullDate,
      props.index,
      props.buildingIndex,
    );
    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name_datepicker,
      e,
      props.index,
      props.buildingIndex,
    );
  };

  if (props.pText) {
    errorBorder = " invalid";
  }

  return (
    <Fragment>
      <div className={props.mb4}>
        <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
          {props.labelText}
          {props.tooltipText && (
            <span className="tooltip">
              <i className="fa-regular fa-circle-question fa-fw"></i>
              <span className="tooltiptext">{props.tooltipText}</span>
            </span>
          )}
        </label>

        <DatePicker
          className={props.inputClassName + errorBorder}
          id={props.inputID}
          selected={props.value}
          lang="ar"
          minDate={parsedMinDate}
          maxDate={parsedMaxDate}
          onChange={(e) => handleDateChange(e)}
          dateFormat="yyyy-MM-dd"
          onKeyDown={handleKeyDown}
          disabled={props.isDisabled}
          placeholderText={props.placeholderText ?? `ادخل ${props.labelText}..`} // Add Arabic placeholder
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: "flex",
                justifyContent: "space-evenly",
                gap: 5,
              }}
            >
              <button
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className="btn-left"
              >
                {<i className="fa-solid fa-angle-right"></i>}
              </button>
              <select
                value={getYear(date)}
                className={`select_datePicker` + errorBorder}
                onChange={({ target: { value } }) => {
                  changeYear(value);
                }}
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                className={`select_datePicker` + errorBorder}
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) => {
                  changeMonth(months.indexOf(value));
                }}
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <button
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className="btn-right"
              >
                {<i className="fa-solid fa-angle-left"></i>}
              </button>
            </div>
          )}
        />
        {props.pText && <p className={props.pClassName}>{props.pText}</p>}
      </div>
    </Fragment>
  );
}

export function DatePickerFormatedWithLimit(props) {
  let errorBorder = "";
  const isValidDate = (date) => {
    const d = new Date(date);
    return !isNaN(d.getTime());
  };

  const minDate = isValidDate(props.minDate)
    ? new Date(props.minDate)
    : new Date(1990, 0, 1);

  const maxDate = isValidDate(props.maxDate)
    ? new Date(props.maxDate)
    : new Date();

  const years = (function () {
    var currentYear = maxDate.getFullYear(),
      years = [];
    let startYear = minDate.getFullYear();
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years;
  })();

  // months in arabic
  const months = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "اكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];

  // Change date format to string format
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("/");
  }
  const handleDateChange = (e) => {
    const fullDate = formatDate(e);
    // set two dates format one for validation with national id
    // and another to datepicker
    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name,
      fullDate,
      props.index,
      props.buildingIndex,
    );
    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name_datepicker,
      e,
      props.index,
      props.buildingIndex,
    );
  };

  if (props.pText) {
    errorBorder = " invalid";
  }

  return (
    <Fragment>
      <div className={props.mb4}>
        <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
          {props.labelText}
          {props.tooltipText && (
            <span className="tooltip">
              <i className="fa-regular fa-circle-question fa-fw"></i>
              <span className="tooltiptext">{props.tooltipText}</span>
            </span>
          )}
        </label>

        <DatePicker
          className={props.inputClassName + errorBorder}
          id={props.inputID}
          selected={props.value}
          lang="ar"
          onChange={(e) => handleDateChange(e)}
          dateFormat="yyyy/MM/dd"
          // minDate={new Date(2025, 0, 1)} // Set minimum selectable date to Jan 1, 2025
          minDate={minDate} // Set minDate dynamically
          maxDate={maxDate} // Set maximum selectable date to today
          placeholderText={props.placeholderText ?? `ادخل ${props.labelText}..`} // Add Arabic placeholder
          renderCustomHeader={({
            date,
            changeYear,
            changeMonth,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div
              style={{
                marginTop: 10,
                marginBottom: 10,
                display: "flex",
                justifyContent: "space-evenly",
                gap: 5,
              }}
            >
              <button
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className="btn-left"
              >
                {<i className="fa-solid fa-angle-right"></i>}
              </button>
              <select
                value={getYear(date)}
                className={`select_datePicker` + errorBorder}
                onChange={({ target: { value } }) => {
                  changeYear(value);
                }}
              >
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                className={`select_datePicker` + errorBorder}
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) => {
                  changeMonth(months.indexOf(value));
                }}
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <button
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className="btn-right"
              >
                {<i className="fa-solid fa-angle-left"></i>}
              </button>
            </div>
          )}
          onChangeRaw={(e) => e.preventDefault()}
        />
        {props.pText && <p className={props.pClassName}>{props.pText}</p>}
      </div>
    </Fragment>
  );
}

export default DatePickerFormated;
